//Libs
import { createSelector } from "reselect";

const selectAutoscan = (state) => state.autoscan;

export const selectAutoscanControl = createSelector(
  [selectAutoscan],
  (autoscan) => autoscan
);
